const ChatIcon = "" + new URL("ChatIcon.png", import.meta.url).href;
export {
  ChatIcon as default
};
//# sourceMappingURL=ChatIcon.png.js.map
